import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=eb54ed18&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=eb54ed18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb54ed18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb54ed18')) {
      api.createRecord('eb54ed18', component.options)
    } else {
      api.reload('eb54ed18', component.options)
    }
    module.hot.accept("./orderDetails.vue?vue&type=template&id=eb54ed18&scoped=true", function () {
      api.rerender('eb54ed18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderManagement/commissionBaseDeductionSetting/orderDetails.vue"
export default component.exports